export const CHOICE = {
  YES: 'YES',
  NO: 'NO',
};

export const CHOICES = {
  YES: true,
  NO: false,
};

export const SET_CLAIM_TO_PREOPEN: string = 'SET_CLAIM_TO_PREOPEN';
export const RESET_PREOPEN_CLAIM: string = 'RESET_PREOPEN_CLAIM';
export const REQUEST_UPDATE_CLAIM: string = 'REQUEST_UPDATE_CLAIM';
export const REQUEST_UPDATE_FRAUD_INFO: string = 'REQUEST_UPDATE_FRAUD_INFO';
export const SET_CLAIM_ID: string = 'SET_CLAIM_ID';

export const INJURY_POST = {
  INJURED: ['0', '1'],
  DECEASED: ['2'],
};
export const INJURY_POST_DECEASED_SAGIS = '104';
export const INJURY_POST_DECEASED = '2';
export const INJURY_POST_INJURED = '0';
export const LINK_FRAUDE_LAWYER =
  'https://forms.office.com/Pages/ResponsePage.aspx?id=g4HnlsnHFESKgx3QyU0VuKOLjVo6zCRGm6T-MeQKkwhUNTRFSzJRUEVINTE4NktZQkFRSjVYRERLQS4u';

export const LINK_FRAUDE_MANAGER =
  'https://forms.office.com/Pages/ResponsePage.aspx?id=g4HnlsnHFESKgx3QyU0VuKOLjVo6zCRGm6T-MeQKkwhUM00zOVlBWktPOERQMERHQThURjNTWEpUVC4u';
export const beneficiaries = [
  {
    id: 1,
    firstName: 'string',
    lastName: 'string',
    age: '12',
    type: '2',
    victimKey: '2222',
  },
  {
    id: 2,
    firstName: 'string2222',
    lastName: 'string3333',
    age: 154,
    type: '1',
    victimKey: '2221',
  },
];

export const BENEFICIARY_OPTIONS = [
  'Ayant-droit touché par une infirmité',
  'Ayant-droit à charge',
];

export const GENDER = { MALE: 'M', FEMALE: 'F' };
export const MINOR_VALUE = '0';

export const OTHER_MOTIF_ID = 20;
export const VICTIM_ITT_AVAILABILITY = {
  AVAILABLE: 'available',
  NOT_AVAILABLE: 'not_available',
};

export const FIND_PROVISIONAL_CLAIM_BY_REFERENCE =
  'FIND_PROVISIONAL_CLAIM_BY_REFERENCE';

export const SET_IS_PROVISIONAL_CLAIM_EXIST = 'SET_IS_PROVISIONAL_CLAIM_EXIST';
